import { expendType } from './expend_type';
import { incomeType } from './income_type';
import { adjustData } from './budget/adjust_data';
import { allCompany } from './budget/all_company';

export default {
  expend_type: expendType,
  income_type: incomeType,
  adjust_data: adjustData,
  all_company: allCompany,
};



// WEBPACK FOOTER //
// ./src/store/modules/finance/reducers.js